<template>
  <van-dialog
    :value="value"
    get-container="body"
    :class-name="dialogClassName"
    :show-confirm-button="false"
    :show-cancel-button="false"
    :close-on-click-overlay="true"
    transition=""
    @input="$emit('input', $event)"
  >
    <div class="private-fund-disclaimer">
      <h3 class="private-fund-disclaimer__title">
        {{ $t("privateFund.disclaimer.title") }}
      </h3>
      <div class="private-fund-disclaimer__body" :class="{ 'is-en': isEn }">
        <p>{{ $t("privateFund.disclaimer.paragraph1") }}</p>
        <p>{{ $t("privateFund.disclaimer.paragraph2") }}</p>
        <p>{{ $t("privateFund.disclaimer.paragraph3") }}</p>
        <p class="private-fund-disclaimer__copyright">
          {{ $t("privateFund.disclaimer.copyright") }}
        </p>
      </div>
      <button
        type="button"
        class="private-fund-disclaimer__btn"
        :class="{ 'is-compact': confirmBtnCompact }"
        @click="handleConfirm"
      >
        {{ $t("privateFund.disclaimer.confirm") }}
      </button>
    </div>
  </van-dialog>
</template>

<script>
import { Dialog } from "vant";
import { getBrowser } from "@/utils/browser";

const browser = getBrowser();

export default {
  name: "DisclaimerDialog",
  components: {
    [Dialog.Component.name]: Dialog.Component
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dialogClassName() {
      const theme = this.$store.getters["common/bgColor"];
      const classes = ["private-fund-disclaimer__dialog"];
      if (theme === "black-theme") {
        classes.push("black-theme-dialog");
      }
      if (browser.isApp) {
        classes.push("is-app");
      }
      return classes.join(" ");
    },
    confirmBtnCompact() {
      return this.$t("privateFund.disclaimer.confirm").length > 16;
    },
    isEn() {
      return this.$i18n.locale === "en";
    }
  },
  methods: {
    handleConfirm() {
      this.$emit("confirm");
      this.$emit("input", false);
    }
  }
};
</script>

<style scoped lang="less">
.private-fund-disclaimer {
  padding: 40px 32px 10px;

  &__title {
    margin: 0;
    color: #171717;
    font-size: 34px;
    font-weight: 600;
    line-height: 48px;
    text-align: center;
  }

  &__body {
    margin-top: 28px;
    max-height: 52vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    p {
      margin: 0 0 20px;
      color: #333;
      font-size: 26px;
      line-height: 40px;
      text-align: justify;
    }

    &.is-en p {
      text-align: left;
      word-spacing: normal;
    }
  }

  &__copyright {
    margin-bottom: 0 !important;
    color: #666;
    font-size: 24px;
    line-height: 36px;
    text-align: center !important;
  }

  &__btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 88px;
    margin-top: 48px;
    padding: 16px 10px;
    border: none;
    border-radius: 44px;
    background: #171832;
    color: #fff;
    font-size: 30px;
    font-weight: 500;
    line-height: 1.35;
    text-align: center;

    &.is-compact {
      font-size: 24px;
    }
  }
}
</style>

<style lang="less">
.van-dialog.private-fund-disclaimer__dialog {
  top: 50%;
  left: 50%;
  width: 620px;
  max-width: calc(100vw - 64px);
  margin: 0;
  border-radius: 24px;
  overflow: hidden;
  transition: none;
  transform: translate3d(-50%, -50%, 0);

  &.is-app {
    transform: translate3d(
      -50%,
      calc(-50% + env(safe-area-inset-top, 40px)),
      0
    );
  }

  .van-dialog__content {
    padding: 0;
  }

  &.black-theme-dialog {
    background-color: #1b1c24;

    .van-dialog__content {
      background-color: #1b1c24;
    }

    .private-fund-disclaimer__title {
      color: #fff;
    }

    .private-fund-disclaimer__body p {
      color: #d0d0d2;
    }

    .private-fund-disclaimer__copyright {
      color: #9d9d9f;
    }

    .private-fund-disclaimer__btn {
      background: #377cfb;
    }
  }
}
</style>
